<template>
  <Loader  v-if="loading"/>
  <div id="nav" v-if="!loading">
    <div @click.stop id="nav-icon1" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <ul id="nav__ul" class="hide" tabindex="-1">
      <li><router-link to="/">Inicio</router-link> </li>
      <li v-if="isAuth"><router-link to="/add">Agregar</router-link></li>
      <li v-if="!isAuth"><router-link to="/login">Iniciar Sesión</router-link></li> 
      <li v-if="isAuth" @click="logOut"><p>Cerrar Sesión</p></li>
    </ul>
    <div class="nav-logo-link">
      <router-link to="/"><img class="nav-logo" src="./assets/col-shopping.png" alt="ConShopping"></router-link>
    </div>
      <a href="https://www.instagram.com/col_shopping/" target="_blank"><img class="instagram-logo" src="./assets/instagram.png" alt="instagram"></a>
  </div>
  <router-view v-if="!loading"/>
</template>

<script>
import { mapState } from 'vuex';
import Loader from "./components/loader.vue"
export default {
  name: "App",
  components:{Loader},
  data() {
    return{
      loading: true,
    }
  },
  computed: mapState(['isAuth']),
  methods:{
    logOut(){
      this.$store.dispatch("logOut")
    },
    toggleMenu(){
      let menu = document.getElementById("nav__ul");
      menu.classList.toggle('hide');
      let menuIcon = document.getElementById("nav-icon1");
      menuIcon.classList.toggle('open')
    }
  },
  created(){
    this.$store.dispatch("verifyAuth")
    .then(()=>{
      setTimeout(()=>{
        this.loading = false;
      }, 1000)
    });
  },
  mounted(){
    document.onclick = function(e){
      if(e.target.id !== 'nav__ul' && e.target.id !== 'imgMenu' && e.target.id !== 'nav-icon1'){
        let menu = document.getElementById("nav__ul");
        menu.classList.add('hide');
        let menuIcon = document.getElementById("nav-icon1");
        menuIcon.classList.remove('open')
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;600&display=swap');
*{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: 'Poppins', sans-serif;;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
}

#nav {
  padding: 1em .9em 0 .9em;
  display: flex;
  flex-direction: row;
  position: relative;
  color: #000;

  .menuImg{
    width: 24px;
    height: 24px;
  }

  a{
      height: fit-content;
  }

  &__ul{
    list-style: none;
    position: absolute;
    top: 50px;
    background-color: #FFF;
    border: 1px solid #ddd;
    border-radius: .5em;
    border-top-left-radius: 0;
    z-index: 999;
    box-shadow: 5px 5px 5px #ddd;
    transition: 0.5s;

    li{
      padding: .3em .5em;
      font-weight: bold;
      a {
        text-decoration: none;
        color: #000;

        &.router-link-exact-active {
          color: #5DF3B3;
        }
      }
      p {
        cursor: pointer;
      }
    }
  }
  .nav-logo-link{
    flex: 1;
  }
  .nav-logo{
    width: 120px;
    position: relative;
    margin: 0 auto;
    cursor: pointer;
  }

  .instagram-logo{
    width: 24px;
    height: 24px;
  }
}

#nav-icon1 {
  width: 24px;
  height: 24px;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;

    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      background: #000000;
      border-radius: 9px;
      opacity: 1;
      left: 0;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: .25s ease-in-out;
      -moz-transition: .25s ease-in-out;
      -o-transition: .25s ease-in-out;
      transition: .25s ease-in-out;
    }
    span:nth-child(1) {
      top: 0px;
    }
    span:nth-child(2) {
      top: 9px;
    }
    span:nth-child(3) {
      top: 18px;
    }
    &.open span:nth-child(1) {
      top: 9px;
      -webkit-transform: rotate(135deg);
      -moz-transform: rotate(135deg);
      -o-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    &.open span:nth-child(2) {
      opacity: 0;
      left: -60px;
    }

    &.open span:nth-child(3) {
      top: 9px;
      -webkit-transform: rotate(-135deg);
      -moz-transform: rotate(-135deg);
      -o-transform: rotate(-135deg);
      transform: rotate(-135deg);
    }
}


.button {
  padding: .3em .5em;
  background: #FFF;
  border: 1px solid #ddd;
  border-radius: .5em;
  text-decoration: none;
  color: #000;
  font-size: .9em;
  height: fit-content;
  cursor: pointer;
  font-weight: bold;
  transition: 0.2s;

  img{
    vertical-align: middle;
  }

  &:hover{
    background: #5DF3B3;
    color: #FFF;
    border:1px solid #5DF3B3;
    img{
      filter: invert(100%);
    }
  }

}

.input-text {
  width: 100%;
  padding: .1em .5em;
  border: 1px solid #ddd;
  border-radius: .5em;
  outline: none;
  background-color: rgba(0, 0, 0, 0.02);
  transition: all 0.2s;

  &:focus, &:hover{
    background: #fff;
    transition: all 0.2s;
  }
}

@media (max-width: 390px) {
    .button{
        img{
          display: none;
        }
    }
}

@media(min-width: 950px){
  #nav{
    height: 120px;
    width: 100%;
    justify-content: space-between;
    .menuImg{
      display: none;
    }

    &__ul{
      position: static;
      border: none;
      display: flex;
      box-shadow: none;
    }

    .nav-logo{
      position: absolute;
      left: 50%;
      margin-left: -60px;
    }
  }
  #nav-icon1{
    display: none;
  }
}
</style>
